import createCrudVuexModule from "@/store/crud";

export const datasubjectRight = createCrudVuexModule({
  namespaced: true,
  path: "/library/datasubject-right",
  moduleName: `datasubject-right`,
});

export const workspaceDatasubjectRight = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/datasubject-right",
});

export const managementDatasubjectRight = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/datasubject-right",
});

export const organizationDatasubjectRight = createCrudVuexModule({
  namespaced: true,
  path: "/datasubject-right",
});
